import { render, staticRenderFns } from "./SpecimenLocationTracking.vue?vue&type=template&id=ddff32b2"
import script from "./SpecimenLocationTracking.vue?vue&type=script&lang=js"
export * from "./SpecimenLocationTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports